import '../css/style.scss';

import Top from './modules/Top';
import NavTop from './modules/NavTop';
import FormBtn from './modules/FormBtn';
import PopUp from './modules/PopUp';

const formBtn = new FormBtn();
const TOP_PAGE = document.querySelector('.home');
if (TOP_PAGE) {
  const top = new Top();
  const popUp = new PopUp();
  const navTop = new NavTop();
}
